import { SMART_SET, SMART_UPDATE } from "../constants";

const initialState = {
  smartMenu: null,
};

export default function smartReducer(state = initialState, action) {
  switch (action.type) {
    case SMART_SET:
      return { ...state, smartMenu: action.smartMenu };

    case SMART_UPDATE:
      return {
        ...state,
        smartMenu: {
          ...state.smartMenu,
          ...action.smartMenu,
        },
      };

    default:
      return state;
  }
}
